import { GetAllRxForImportQuery } from 'src/app/services/api-service/rx/rx-api';
import { IEntity } from 'src/app/shared/models/i-entity';
import { ValueTextPair, ValueTextPairAnyValue, ValueTextPairNumberValue } from 'src/app/shared/models/value-text-pair';

export const ProductTypes: ValueTextPairNumberValue[] = [{ text: '一般商品', value: 1 }, { text: '組合商品', value: 2 }];
export const SaleTaxTypes: ValueTextPairNumberValue[] = [{ text: '應稅', value: 1 }, { text: '免稅', value: 0 }];
export const StockTaxTypes: ValueTextPairNumberValue[] = [{ text: '應稅', value: 1 }, { text: '免稅', value: 0 }];
export const StockTypes: ValueTextPairNumberValue[] = [{ text: '一般商品', value: 1 }, { text: '母商品', value: 2 }];
export const OrderTypes: ValueTextPairNumberValue[] = [{ text: '請購(總公司採購)', value: 1 }, { text: '需求(倉庫出貨)', value: 2 }];
export const CalculateTypes: ValueTextPairNumberValue[] = [{ text: '依數量', value: 1 }, { text: '依金額', value: 2 }];
export const YesNo: ValueTextPairAnyValue[] = [{ text: '是', value: true }, { text: '否', value: false }];
export const DefaultOrderPriceTaxType = 0;
export const DefaultOrderPriceTaxRate = 0.05;
export const DefaultSalePriceTaxRate = 0.05;
export const DefaultEditOptions: ProductEditOptions = {
  vendors: [],
  productDepartments: [],
  productCategories: [],
  productCombines: [],
  productCombinePrices: [],
  units: [],
  productTypes: ProductTypes,
  stockTypes: StockTypes,
  saleTaxTypes: SaleTaxTypes,
  stockTaxTypes: StockTaxTypes
};

export interface ProductBarcodeDto extends IEntity {
  CompanyId: number | null;
  ProductId: number | null;
  ProductCode: string;
  Barcode: string;
  IsEnabled: boolean;
  IsAlive: boolean;
  ErrorMessage?: string;
  AllowError?: boolean;
}

/** 醫令庫存檢核：換算後子商品的庫存不足明細 */
export interface RxStockShortageDto {
  ProductCode: string;
  ProductName: string;
  RequiredQty: number;
  CurrentQty: number;
  SafeStock: number;
}

export interface RxStockBatchResultDto {
  Index: number;
  HasStock: boolean;
  Shortages: RxStockShortageDto[];
}

/**
 * 商品售價同步時，顯示其關聯藥材的資訊
 */
export interface RelatedRxForSyncDto {
  RxId: number;
  ClinicId: number;
  ClinicName: string;
  RxCode: string;
  StdCode: string;
  ProdName: string;
  Price: number | null;
}

/**
 * 藥材自費價同步時，顯示其對應商品的資訊
 */
export interface RelatedProductForSyncDto {
  ProductId: number;
  ProductCode: string;
  ProductName: string;
  FixPrice: number;
  SalePrice: number;
}

export interface ProductRxDto extends IEntity {
  CompanyId: number | null;
  ClinicId: number | null;
  ProductId: number | null;
  ProductCode: string;
  RxId: number | null;
  RxCode?: string;
  RxName?: string;
  IsEnabled?: boolean;
  IsAlive?: boolean;
  ErrorMessage?: string;
  AllowError?: boolean;
}

export interface ProductDto extends IEntity {
  CompanyId: number | null;
  ProductCode: string;
  Barcode: string;
  VendorSelfCode: string;
  ProductName: string;
  PrintName: string;
  EnglishName: string;
  ProductDepartmentId: number | null;
  ProductCategoryId: number | null;
  VendorId: number | null;
  VendorCode: string;
  ProductCombineId: number | null;
  ProductCombineCode: string;
  Spec: string;
  Unit: string;
  BoxQty: number | null;
  OriginCode: string;
  ProductType: number;
  FixPrice: number;
  SalePrice: number;
  MemberPrice: number;
  EmployeePrice: number;
  OrderPrice: number;
  EstimatedProfit: number;
  SaleTaxType: number;
  StockTaxType: number;
  IsOpenSalePrice: boolean;
  IsOpenOrderPrice: boolean;
  IsDiscount: boolean;
  IsInventory: boolean;
  StockType: number;
  OrderType: number;
  CalculateType: number;
  AmountCostRate: number;
  IsProductStatus: boolean;
  IsStopSale: boolean;
  IsStopStock: boolean;
  IsStopReturn: boolean;
  IsStopOrder: boolean;
  StopSaleDate: Date | null;
  StopStockDate: Date | null;
  StopReturnDate: Date | null;
  StopOrderDate: Date | null;
  IsUseBatchNo: boolean;
  ExpirationDays: number | null;
  ExpirationAlertDays: number | null;
  Remark: string;
  IsEnabled: boolean;
  IsAlive: boolean;
  ProductBarcodes?: ProductBarcodeDto[];
  ProductRxs?: ProductRxDto[];
}

export interface ProductListDto extends IEntity {
  ProductCode: string;
  Barcode: string;
  ProductName: string;
  VendorName?: string;
  SalePrice: number;
  SaleTaxType: number;
  IsOpenSalePrice: boolean;
  StockTaxType: number;
  IsOpenOrderPrice: boolean;
  IsProductStatus: boolean;
  IsStopSale: boolean;
  IsStopStock: boolean;
  IsProductCombine: boolean;
  IsProductParent: boolean;
  IsProductChildren: boolean;
  Spec?: string;
  Unit?: string;
  ProductType?: number;
  StockType?: number;
  IsInventory?: boolean;
  IsUseBatchNo?: boolean;
  IsStopReturn?: boolean;
}

export interface ProductQuery {
  productCode?: string;
  productCodeStart?: string;
  productCodeEnd?: string;
  barcode?: string;
  vendorSelfCode?: string;
  rxCode?: string;
  productName?: string;
  vendorCode?: string;
  productType?: number;
  stockType?: number;
  isProductStatus?: boolean;
  hideDisabled?: boolean;
  modifiedDate?: string;
  isUseBatchNo?: boolean;
  pageSkip?: number;
  pageSize?: number;
}

export interface ProductBatchModifyDto {
  ProductIds: number[];
  ApplyVendor: boolean;
  VendorId: number | null;
  ApplySpec: boolean;
  Spec: string;
  ApplyUnit: boolean;
  Unit: string;
  ApplySaleTaxType: boolean;
  SaleTaxType: number;
  ApplyIsOpenSalePrice: boolean;
  IsOpenSalePrice: boolean;
  ApplyStockTaxType: boolean;
  StockTaxType: number;
  ApplyIsOpenOrderPrice: boolean;
  IsOpenOrderPrice: boolean;
  ApplyIsInventory: boolean;
  IsInventory: boolean;
  ApplyIsUseBatchNo: boolean;
  IsUseBatchNo: boolean;
  ApplyIsProductStatus: boolean;
  IsProductStatus: boolean;
  ApplyIsStopSale: boolean;
  IsStopSale: boolean;
  ApplyStopSaleDate: boolean;
  StopSaleDate: string | null;
  ApplyIsStopStock: boolean;
  IsStopStock: boolean;
  ApplyStopStockDate: boolean;
  StopStockDate: string | null;
  ApplyIsStopReturn: boolean;
  IsStopReturn: boolean;
  ApplyStopReturnDate: boolean;
  StopReturnDate: string | null;
  ApplyExpirationDays: boolean;
  ExpirationDays: number | null;
  ApplyExpirationAlertDays: boolean;
  ExpirationAlertDays: number | null;
}

export interface ProductBatchModifyErrorDto {
  ProductId: number;
  ProductCode: string;
  Reason: string;
}

export interface ProductBatchModifyResultDto {
  SuccessCount: number;
  FailedCount: number;
  Errors: ProductBatchModifyErrorDto[];
}

export interface AllCodesDuplicationQuery {
  productCode?: string;
  barcode?: string;
  vendorSelfCode?: string;
  excludeProductId?: number;
  excludeBarcodeId?: number;
}

export interface AllRxsDuplicationQuery {
  rxId?: number;
  excludeProductRxId?: number;
}

export interface ProductPageResult {
  total: number;
  data: ProductListDto[];
}

export interface EditOptions {
  vendors: ValueTextPair[];
  productDepartments: ValueTextPair[];
  productCategories: ValueTextPair[];
  productCombines: ValueTextPair[];
  productCombinePrices: ValueTextPair[];
  units: ValueTextPair[];
}

export interface ProductEditOptions extends EditOptions {
  productTypes: ValueTextPairNumberValue[];
  stockTypes: ValueTextPairNumberValue[];
  saleTaxTypes: ValueTextPairNumberValue[];
  stockTaxTypes: ValueTextPairNumberValue[];
}

export class ProductImportDto {
  SelectedCount: number = 0;
  ProductId: number = 0;
  RxIds: number[] = [];
  UseQueryCondition: boolean = false;
  QueryCondition?: GetAllRxForImportQuery = null;
  NonStockItems: { RxCode: string; ProdName: string }[] = [];
}

export interface StockQuery {
  clinicCode?: string;
  startDate?: Date;
  endDate?: Date;
  startMonth?: Date;
  endMonth?: Date;
}

/** 登入庫存警示檢查結果 (CheckStockAlert API) */
export interface LoginStockAlertDto {
  /** 低於安全庫存筆數 */
  LowStockCount: number;
  /** 批號即將到期筆數 (未停用) */
  BatchNearExpiryCount: number;
  /** 批號已過期筆數 (未停用) */
  BatchExpiredCount: number;
  /** 閒置批號筆數 (未停用、建檔滿3個月、期間無單據異動且庫存量為0) */
  InactiveBatchCount: number;
}
